import React, {useEffect, useState} from 'react';

import {useParams} from 'react-router-dom';


async function readingEdit(authFetch, info) {
    return await authFetch(`${process.env.REACT_APP_API_URL}/reading/update`, {
        method: 'PUT',
        body: JSON.stringify(info),
    });
}


export default function ReadingEdit({authFetch}) {
    const [user, setUser] = useState([]);

    const {readingId} = useParams();
    const [origReading, setOrigReading] = useState('');
    const [origType, setOrigType] = useState('');

    const [dateTime, setDateTime] = useState('');
    const [activeAmount, setActiveAmount] = useState([]);
    const [note, setNote] = useState('');
    const [typeId, setTypeId] = useState('');


    useEffect(() => {
        const fetchUserProfile = async () => {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/user/profile`);
            const data = await response.json();
            setUser(data);
        };
        const fetchReading = async () => {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/reading/${readingId}`);
            const data = await response.json();
            setOrigReading(data);
        };

        fetchUserProfile();
        fetchReading();
    }, [authFetch, readingId]);

    // Separate this from the previous useEffect to prevent infinity loop
    useEffect(() => {
        const fetchUserType = async (typeId) => {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/type/${typeId}`);
            const data = await response.json();
            setOrigType(data);
        };

        setDateTime(origReading.dateTime);
        setActiveAmount(String(origReading.activeAmount));
        setNote(String(origReading.note));
        setTypeId(origReading.typeId);
        typeId !== undefined && fetchUserType(typeId);
    }, [authFetch, origReading, typeId]);

    const userId = user._id;


    const handleSubmit = async e => {
        e.preventDefault();
        await readingEdit(authFetch, {
            readingId,
            typeId,
            activeAmount,
            dateTime,
            note,
            userId,
        });
        window.location.href = '/type/' + typeId;
    };


    return (
        <>
            <h2>Edit Reading</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    <p>{origType.name} Amount ({origType.activeUnits})</p>
                    <input type="number" value={activeAmount} onChange={e => setActiveAmount(e.target.value)}/>
                </label>
                <label>
                    <p>Date/Time</p>
                    <input type="text" value={dateTime} onChange={e => setDateTime(e.target.value)}/>
                </label>
                <label>
                    <p>Notes (optional)</p>
                    <input type="text" value={note} onChange={e => setNote(e.target.value)}/>
                </label>
                <div>
                    <button type="submit">Edit</button>
                </div>
            </form>
        </>
    );
}